<template>
  <div class="text-center">
    <div class="header px-2 pb-1">
      <img
        alt="success"
        width="66px"
        :src="topUpInprocessImg"
      >
      <h3 class="my-1">
        {{ $t('payment.wiseTransfer.titleTopupInprocess') }}
      </h3>
      <p>{{ $t('payment.wiseTransfer.subTitleTopupInprocess') }}</p>
    </div>
    <div class="summary p-2">
      <h4
        id="title-summary-wise"
        data-testid="title-summary-wise"
        class="text-left mb-2"
      >
        {{ $t('addFundPage.creditCardPayment.textSummary') }}
      </h4>
      <div class="d-flex align-items-center justify-content-between mb-1 flex-wrap">
        <div
          id="summary-title-client-wise"
          data-testid="summary-title-client-wise"
          class="font-14 text-placeholder"
        >
          {{ $t('addFundPage.creditCardPayment.textClient') }}
        </div>
        <strong
          id="summary-client-name-wise"
          data-testid="summary-client-name-wise"
        >
          {{ fullName }}
        </strong>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-1">
        <div
          id="summary-wise-title-amount"
          data-testid="summary-wise-title-amount"
          class="font-14 text-placeholder"
        >
          {{ $t('balance.textAmount') }}
        </div>
        <strong
          id="summary-wise-order-amount"
          data-testid="summary-wise-order-amount"
        >
          {{ localStringFormat(amount) }} USD
        </strong>
      </div>

      <div
        v-if="paymentMethod.paymentMethod"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="summary-title-wise-method"
          class="font-14 text-placeholder"
        >
          {{ $t('addFundPage.creditCardPayment.textPaymentMethod') }}
        </div>
        <div class="d-flex align-items-center">
          <img
            :src="getBrandIcon(paymentMethod.paymentMethod)"
            alt="payment"
            style="margin-right: 6px;width: 26px"
          >
          <strong
            id="summary-current-wise-method"
            data-testid="summary-current-wise-method"
          >{{ convertNamePayment(paymentMethod.paymentMethod) }}</strong>
        </div>
      </div>

      <div
        v-else-if="paymentMethod.type"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="summary-wise-title-method-type"
          data-testid="summary-wise-title-method-type"
          class="font-14 text-placeholder"
        >
          {{ $t('addFundPage.creditCardPayment.textPaymentMethod') }}
        </div>
        <div
          id="summary-wise-method-type"
          data-testid="summary-wise-method-type"
          class="d-flex align-items-center"
        >
          <img
            :src="getBrandIcon(paymentMethod.type)"
            alt="payment"
            style="margin-right: 6px;width: 26px"
          >
          <strong
            id="summary-wise-current-payment-type"
            data-testid="summary-wise-current-payment-type"
          >{{ convertNamePayment(paymentMethod.type) }}</strong>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-1">
        <div
          id="summary-wise-title-currency"
          data-testid="summary-wise-title-currency"
          class="font-14 text-placeholder"
        >
          {{ $t('account.currency') }}
        </div>
        <div>
          <strong
            id="summary-wise-currency"
            data-testid="summary-wise-currency"
          >{{ paymentMethod.value }}</strong>
        </div>
      </div>

      <div
        v-if="paymentMethod.bankLocation"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="summary-wise-title-account-location"
          data-testid="summary-wise-title-account-location"
          class="font-14 text-placeholder"
        >
          {{ $t('payment.wiseTransfer.labelAccountLocation') }}
        </div>
        <div v-if="amount">
          <img
            v-if="paymentMethod.icon"
            :src="paymentMethod.icon"
            width="18px"
            alt="coin"
            style="margin-right: 6px"
          >
          <strong
            id="summary-wise-bank-location"
            data-testid="summary-wise-bank-location"
          >{{ paymentMethod.bankLocation }}</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>

      <div
        v-if="percentFee || (detailInfo && detailInfo.serviceCharge)"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="summary-wise-title-service-charge"
          data-testid="summary-wise-title-service-charge"
          class="font-14 text-placeholder"
        >
          {{ $t('payment.balanceTransactionsTable.textServiceCharge') }}
        </div>
        <strong
          id="summary-wise-current-service-charge"
          data-testid="summary-wise-current-service-charge"
          class="theme-text-primary"
        >{{ serviceCharge }} USD</strong>
      </div>

      <div
        v-if="methodFee || (detailInfo && detailInfo.paymentGateCharge)"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="summary-title-wise-fee"
          data-testid="summary-title-wise-fee"
          class="font-14 text-placeholder"
        >
          {{ $t('payment.paypal.textPaymentFee', {payment:"Wise"}) }}
        </div>
        <div>
          <div
            class="d-flex align-items-center"
          >
            <strong
              id="summary-current-wise-fee"
              data-testid="summary-current-wise-fee"
              class="text-primary"
            >{{ wiseFee }} USD</strong>
          </div>
        </div>
      </div>

      <div
        v-if="taxRate || (detailInfo && detailInfo.taxCharge)"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="summary-wise-title-tax-fee"
          data-testid="summary-wise-title-tax-fee"
          class="font-14 text-placeholder"
        >
          {{ $t('payment.balanceTransactionsTable.textTax') }}
        </div>
        <div>
          <strong
            id="summary-wise-current-tax-fee"
            data-testid="summary-wise-current-tax-fee"
            class="theme-text-primary"
          >{{ tax }} USD</strong>
        </div>
      </div>

      <div
        v-if="tipAmount > 0"
        class="d-flex align-items-center justify-content-between mb-1"
      >
        <div
          id="summary-wise-title-tip-amount"
          data-testid="summary-wise-title-tip-amount"
          class="font-14 text-placeholder"
        >
          Tip
        </div>
        <strong
          id="summary-wise-current-tip-amount"
          data-testid="summary-wise-current-tip-amount"
          class="text-primary"
        >{{ tipAmountTxt }} USD</strong>
      </div>

      <hr class="hr-custom">

      <div class="d-flex align-items-center justify-content-between">
        <div class="font-14 text-placeholder text-left">
          {{ $t('addFundPage.creditCardPayment.textTotalAmount') }} = {{ $t('balance.textAmount') }}
          {{ percentFee || (detailInfo && detailInfo.serviceCharge) ? ` + ${$t('payment.balanceTransactionsTable.textServiceCharge')}` : '' }}
          {{ taxRate || (detailInfo && detailInfo.taxCharge) ? ` + ${$t('payment.balanceTransactionsTable.textTax')}` : '' }}
          {{ methodFee || (detailInfo && detailInfo.paymentGateCharge) ? ` + ${$t('payment.paypal.textPaymentFee', {payment:"Wise"})}` : '' }}
          {{ tipAmount > 0 ? ' + Tip' : '' }}
        </div>
      </div>
      <h3
        id="summary-wise-current-total-amount"
        data-testid="summary-wise-current-total-amount"
        class="mt-2 text-left"
      >
        {{ totalAmount }} USD
      </h3>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import _get from 'lodash/get'
import { bus } from '@/plugins/bus'

import numberFormatMixin from '@/mixins/numberFormatMixin'
import paymentMixin from '@/mixins/paymentMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import { PAYMENT_METHOD } from '@/constants'

const { mapGetters } = createNamespacedHelpers('payment')
const { mapGetters: mapGettersAuth } = createNamespacedHelpers('auth')

export default {
  components: {},
  mixins: [numberFormatMixin, generalConfigsMixin, paymentMixin, stepGuideMixin],
  props: {
    paymentMethod: {
      type: Object,
      required: true,
    },

    // eslint-disable-next-line vue/require-default-prop
    detailInfo: {
      type: Object,
      required: false,
    },

    transfer: {
      type: Object,
      required: true,
    },

    amount: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      showSuccessPage: true,
      historyTicket: {},
    }
  },

  create() {
    this.$emit('handleShowSuccessPage', this.showSuccessPage)
  },

  computed: {
    ...mapGetters(['listCard', 'loading', 'listTicket']),
    ...mapGettersAuth(['user', 'generalConfigs']),

    isShowBtnBackToDemoView() {
      return this.hasStepGuide && this.user?.data?.balance > 0
    },

    fullName() {
      const fullName = _get(this.user, ['data', 'fullName'], '')
      const email = _get(this.user, ['data', 'email'], '')
      return fullName || email
    },

    percentFee() {
      return this.user?.data?.plans?.transferFee?.transferWise || 0
    },

    methodFee() {
      return this.generalConfigs?.paymentGateFee?.transferWiseGate || 0
    },

    methodFeeTxt() {
      return `${(this.methodFee * 100).toFixed(2)}%`
    },

    wiseFee() {
      if (!this.detailInfo) {
        return this.amountFormat(this.methodFee * this.amount)
          .toLocaleString('en-US')
      }
      if (this.detailInfo?.paymentGateCharge) {
        return this.detailInfo?.paymentGateCharge
      }
      return 0
    },

    serviceCharge() {
      if (!this.detailInfo) {
        return this.amountFormat(this.percentFee * this.amount)
          .toLocaleString('en-US')
      }

      if (this.detailInfo?.serviceCharge) {
        return this.detailInfo?.serviceCharge
      }

      return 0
    },

    tipAmount() {
      return this.historyTicket?.details?.tipAMAmount || null
    },

    tipAmountTxt() {
      return this.amountFormat(this.tipAmount)
        .toLocaleString('en-US')
    },

    totalAmount() {
      if (!this.detailInfo) {
        const fee = this.amountFormat(this.percentFee * this.amount)
        const tax = this.amountFormat(this.taxRate * this.amount)
        const methodFee = this.amountFormat(this.methodFee * this.amount)
        return (this.amount + fee + tax + methodFee + this.tipAmount).toLocaleString('en-US')
      }

      const {
        serviceCharge,
        taxCharge,
        paymentGateCharge,
      } = this.detailInfo

      return (this.amount + serviceCharge + taxCharge + paymentGateCharge + this.tipAmount).toLocaleString('en-US')
    },

    percentTaxTxt() {
      return `${(this.taxRate * 100).toFixed(2)}%`
    },

    tax() {
      if (!this.detailInfo) {
        return this.amountFormat(this.taxRate * this.amount)
          .toLocaleString('en-US')
      }

      if (this.detailInfo?.taxCharge) {
        return this.detailInfo?.taxCharge
      }

      return 0
    },
  },

  watch: {
    listTicket: {
      handler(ticket) {
        if (ticket.paging.total > 0) {
          this.historyTicket = ticket.content?.find(transaction => transaction.details.paymentMethod === PAYMENT_METHOD.TRANSFERWISE)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    bus.$on('set-invoice-data', data => {
      this.amount = data.amount
    })
  },
}
</script>
<style lang="scss" scoped>
.hr-custom {
  border-top: 1px solid #EEEEEE;
}

.summary {
  border-radius: var(--border-radius-base);
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  background-color: #fff;
}
</style>
